"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationEllipsis } from "@/components/ui/pagination";
import { Button } from "@/components/ui/button";
export default function NavegacionDePaginacion() {
  const currentPage = 2;
  const totalPages = 8;
  return <section id="navegación-de-paginación" className="bg-background py-12 sm:py-16">
      <div className="container mx-auto px-4">
        <Pagination className="flex justify-center">
          <PaginationContent className="gap-1 sm:gap-2">
            {}
            <PaginationItem data-index={0}>
              <Link to="#" className="no-underline">
                <Button variant="ghost" size="sm" className="gap-1 px-3 text-foreground font-display text-sm hover:translate-x-[-3px] transition-transform duration-[var(--duration-fast)]" disabled={currentPage === 1}>
                  <ChevronLeft className="size-4" />
                  <span className="hidden sm:inline">Anterior</span>
                </Button>
              </Link>
            </PaginationItem>

            {}
            <PaginationItem data-index={1}>
              <PaginationLink href="#" className="font-display text-sm min-w-[32px] h-8 rounded-full border-none hover:bg-transparent">
                1
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem data-index={2}>
              <PaginationLink href="#" isActive className="font-display text-sm min-w-[32px] h-8 rounded-full border-2 border-accent bg-transparent text-foreground hover:bg-accent/10 shadow-none">
                2
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem data-index={3}>
              <PaginationLink href="#" className="font-display text-sm min-w-[32px] h-8 rounded-full border-none hover:bg-transparent">
                3
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem data-index={4}>
              <PaginationLink href="#" className="font-display text-sm min-w-[32px] h-8 rounded-full border-none hover:bg-transparent">
                4
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem data-index={5}>
              <PaginationLink href="#" className="font-display text-sm min-w-[32px] h-8 rounded-full border-none hover:bg-transparent">
                5
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem data-index={6}>
              <PaginationEllipsis className="text-muted-foreground" />
            </PaginationItem>

            {}
            <PaginationItem data-index={7}>
              <PaginationLink href="#" className="font-display text-sm min-w-[32px] h-8 rounded-full border-none hover:bg-transparent">
                {totalPages}
              </PaginationLink>
            </PaginationItem>

            {}
            <PaginationItem data-index={8}>
              <Link to="#" className="no-underline">
                <Button variant="ghost" size="sm" className="gap-1 px-3 text-foreground font-display text-sm hover:translate-x-[3px] transition-transform duration-[var(--duration-fast)]" disabled={currentPage === totalPages}>
                  <span className="hidden sm:inline">Siguiente</span>
                  <ChevronRight className="size-4" />
                </Button>
              </Link>
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </section>;
}